import { Directive, Input, forwardRef } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';

const UNIQUE_ID_VALIDATOR: any = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => UniqueIdValidator),
    multi: true
};

/**
 * Class to configure unique-id-validate directive
 */
export class UniqueIdConfig {
    source: Array<any> = [];
    key: string = "id";
    excludeKey: string = "id";
    excludeValue: any = undefined;
    caseSensitive: boolean = true;
}

@Directive({
    selector: '[uniqueIdValidate][formControlName], [uniqueIdValidate][formControl], [uniqueIdValidate][ngModel]',
    providers: [UNIQUE_ID_VALIDATOR]
})
export class UniqueIdValidator implements Validator {
    @Input('uniqueIdValidate') config: UniqueIdConfig;

    private compare(a, b): boolean {
        return typeof a === 'string' && typeof b === 'string'
            ? (this.config.caseSensitive ? a === b : a.toLowerCase() === b.toLowerCase())
            : a === b;
    }

    validate(c: AbstractControl): { [key: string]: any } {
        if (!this.config || !this.config.source || !this.config.source.length) return null;
        var result: Array<any> = this.config.source.filter(s => this.compare(s[this.config.key], c.value) && (this.config.excludeValue === undefined || !this.compare(s[this.config.excludeKey], this.config.excludeValue)));
        if (!result.length) return null;

        return { uniqueIdValidate: { valid: false } };
    }
}

